// extracted by mini-css-extract-plugin
module.exports = {"icon":"Login_icon__GUhdW","buttons":"Login_buttons__2vZly"};